/* eslint-disable prefer-template */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return, no-param-reassign */
import axios from "axios";
import { API_URL } from "../../../constants/index";
import {
    createStore,
    createHook,
    createContainer,
    createSubscriber,
} from "react-sweet-state";

const StoreStaked = createStore({
    initialState: {

    },
    actions: {
        updateStaked:
            (params) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`${API_URL}pool/staked`, { ...params }).then((res) => {

                            resolve(res)
                        });
                    });
                },
        listPool:
            (param) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`${API_URL}stacking-pool/list`, { ...param })
                            .then((res) => {
                                resolve(res?.data?.data)
                            })

                    });
                },
        detailPool:
            (param) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.get(`${API_URL}stacking-pool/detail?poolId=${param}`)
                            .then((res) => {
                                resolve(res?.data?.data || null)
                            })
                            .catch((err) => {
                                reject(null)
                            })
                    });
                },
        // V2 staking pools used by the V1 -> V2 restaking flow.
        listStakingTokenV2:
            (param) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios
                            .get(
                                `${API_URL}staking-token?limit=${param?.limit || 50}&page=${param?.page || 1}`
                            )
                            .then((res) => {
                                resolve(res?.data?.data?.results || [])
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    });
                },
        callNoti:
            (params) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`https://noti-tnx-bot-dev.metatech.foundation/stake/message`, { ...params }).then((res) => {

                            resolve(res)
                        });
                    });
                },
        logStaking:
            (params) =>
                ({ getState, setState }) => {
                    return new Promise((resolve, reject) => {
                        axios.post(`${API_URL}stacking-pool/log`, { ...params }).then((res) => {
                            resolve(res)
                        });
                    });
                },
        addHistory:
            (params) =>
                ({ getState, setState }) => {
                    // return new Promise((resolve, reject) => {
                    //     axios.post(`${API_URL}account/add-history`, { ...params }).then((res) => {
                    //         resolve(res)
                    //     });
                    // });
                },
    },
    name: "StoreStaked",
});

export const useHookStaked = createHook(StoreStaked);
export const Container = createContainer(StoreStaked, {
    onInit:
        () =>
            ({ setState }, props) => {
                setState({ ...props });
            },
});
export const Subscriber = createSubscriber(StoreStaked);
